import React from 'react';
import UploadBlockerPopup from './UploadBlockerPopup';

// Kept as the public entry point so existing call sites keep working; the actual
// UI is the redesigned UploadBlockerPopup (classic + new-UI variants).
export const VideoPopupModal = ({ onHide, isVisible, variant = 'default' }) => (
  <UploadBlockerPopup isVisible={isVisible} onHide={onHide} variant={variant} />
);
